<!-- 平台管理 - 分销任务汇总 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div
                class="admin-content"
                :style="{ minHeight: adminContentMinHeight + 'px' }"
            >
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 分销任务汇总</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form task-query-form">
                        <el-form
                            ref="taskSummaryQueryForm"
                            :model="taskSummaryQueryForm"
                        >
                            <el-row :gutter="20">
                                <el-col :span="1" class="el-align-right">
                                    <i
                                        :class="{
                                            'is-active':
                                                taskSummaryQueryExpanded,
                                        }"
                                        class="el-collapse-item__arrow el-icon-arrow-right task-query-expander"
                                        title="展开更多查询条件"
                                        @click="toggleTaskSummaryQueryExpand"
                                    ></i>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item prop="taskSource">
                                        <el-select
                                            v-model="
                                                taskSummaryQueryForm.taskSource
                                            "
                                            clearable
                                            placeholder="任务类型"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="车主服务任务"
                                                :value="1"
                                            ></el-option>
                                            <el-option
                                                label="团队长任务"
                                                :value="2"
                                            ></el-option>
                                            <el-option
                                                label="任务市场"
                                                :value="4"
                                            ></el-option>
                                            <el-option
                                                label="清单归档任务"
                                                :value="3"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <el-form-item prop="taskId">
                                        <el-input
                                            v-model="
                                                taskSummaryQueryForm.taskId
                                            "
                                            clearable
                                            placeholder="任务ID"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <template v-if="loginUser.userType == 0">
                                    <el-col :span="5">
                                        <el-form-item prop="taskProduceOrgId">
                                            <el-select
                                                v-model="
                                                    taskSummaryQueryForm.taskProduceOrgId
                                                "
                                                clearable
                                                filterable
                                                :filter-method="filterAllOrgs"
                                                @visible-change="
                                                    resetOrgSelectFilterQuery
                                                "
                                                placeholder="任务发布方(来款公司)"
                                                class="el-full-width"
                                            >
                                                <el-option
                                                    v-for="item in taskSummaryQueryOrgSelectOptions"
                                                    :key="item.orgId"
                                                    :label="item.orgName"
                                                    :value="item.orgId"
                                                    class="org-select-option"
                                                >
                                                    <span class="option-left">{{
                                                        item.orgCode
                                                    }}</span>
                                                    <span
                                                        class="option-right"
                                                        >{{
                                                            item.orgName
                                                        }}</span
                                                    >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item prop="taskConsumeOrgId">
                                            <el-select
                                                v-model="
                                                    taskSummaryQueryForm.taskConsumeOrgId
                                                "
                                                clearable
                                                filterable
                                                :filter-method="filterAllOrgs"
                                                @visible-change="
                                                    resetOrgSelectFilterQuery
                                                "
                                                placeholder="任务接受方(服务公司)"
                                                class="el-full-width"
                                            >
                                                <el-option
                                                    v-for="item in taskSummaryQueryOrgSelectOptions"
                                                    :key="item.orgId"
                                                    :label="item.orgName"
                                                    :value="item.orgId"
                                                    class="org-select-option"
                                                >
                                                    <span class="option-left">{{
                                                        item.orgCode
                                                    }}</span>
                                                    <span
                                                        class="option-right"
                                                        >{{
                                                            item.orgName
                                                        }}</span
                                                    >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </template>
                                <el-col :span="6">
                                    <el-form-item class="el-align-center">
                                        <el-button
                                            @click="resetTaskSummaryQueryForm"
                                            icon="fas fa-undo"
                                            >重 置</el-button
                                        >&nbsp;&nbsp;
                                        <el-button
                                            type="primary"
                                            @click="queryTaskSummaryList(1000)"
                                            icon="fas fa-search"
                                            >查 询</el-button
                                        >
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row
                                :gutter="20"
                                v-show="taskSummaryQueryExpanded"
                            >
                                <el-col :span="1">&nbsp;&nbsp;</el-col>
                                <el-col :span="6">
                                    <el-form-item prop="distributeDateRange">
                                        <el-date-picker
                                            style="width: 100%"
                                            v-model="
                                                taskSummaryQueryForm.distributeDateRange
                                            "
                                            clearable
                                            type="daterange"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            start-placeholder="服务日期(开始)"
                                            end-placeholder="服务日期(结束)"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="leaderStaffId">
                                        <el-select
                                            v-model="
                                                taskSummaryQueryForm.leaderStaffId
                                            "
                                            placeholder="团队长(支持名称或身份证模糊搜索)"
                                            clearable
                                            filterable
                                            remote
                                            :remote-method="loadLeaderStaffs"
                                            :loading="leaderStaffQueryLoading"
                                            @clear="
                                                clearLeaderStaffQuerySelectOptions
                                            "
                                            class="el-full-width"
                                        >
                                            <el-option
                                                v-for="item in leaderStaffQuerySelectOptions"
                                                :key="item.staffId"
                                                :label="item.staffName"
                                                :value="item.staffId"
                                                class="leader-select-option"
                                            >
                                                <span class="option-left">{{
                                                    item.idcard
                                                }}</span>
                                                <span class="option-right">{{
                                                    item.staffName
                                                }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="distributeAmounts">
                                        <el-input
                                            v-model="
                                                taskSummaryQueryForm.distributeAmounts
                                            "
                                            placeholder="任务金额(不含税)"
                                            clearable
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item prop="onlyShowMyDistributes">
                                        <el-checkbox
                                            v-model="
                                                taskSummaryQueryForm.onlyShowMyDistributes
                                            "
                                            true-label="true"
                                            false-label=""
                                            >仅显示我分派的任务?</el-checkbox
                                        >
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div v-if="notVispGuest()" class="el-search-toolbar">
                        <el-dropdown
                            size="small"
                            trigger="click"
                            placement="bottom-start"
                            @command="exportTaskSummary"
                        >
                            <el-button
                                size="small"
                                icon="fas fa-download"
                                :loading="submiting"
                                type="primary"
                            >
                                导出清单<i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="2"
                                    >导出清单(报价)</el-dropdown-item
                                >
                                <el-dropdown-item :command="1"
                                    >导出清单(成本)</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button
                            style="margin-left: 10px"
                            type="primary"
                            size="small"
                            icon="fas fa-upload"
                            @click="openArchiveTaskImportDialog()"
                            >导入清单</el-button
                        >
                    </div>
                    <div class="el-search-list">
                        <el-table
                            ref="taskSummaryTable"
                            v-loading="taskSummaryQueryLoading"
                            element-loading-text="拼命加载中..."
                            element-loading-custom-class="el-loading-mask-opacity"
                            :class="{ loading: taskSummaryQueryLoading }"
                            :data="taskSummaryList"
                            :default-sort="taskSummaryQuerySort"
                            @sort-change="onTaskSummaryQuerySortChange"
                            @selection-change="onTaskSummarySelectionChange"
                            style="width: 100%"
                            class="el-table-overflow-x-hidden"
                            empty-text="暂无数据"
                        >
                            <el-table-column
                                type="selection"
                                width="40"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="#"
                                type="index"
                                width="50"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="任务发布方"
                                prop="taskProduceOrgName"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="任务接受方"
                                prop="taskConsumeOrgName"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="团队长"
                                prop="leaderStaffName"
                                width="180"
                                align="center"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <div>{{ scope.row.leaderStaffName }}</div>
                                    <div class="idcard">
                                        {{ scope.row.leaderStaffIdcard }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="金额"
                                prop="distributeAmounts"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="含税金额"
                                prop="taxedDistributeAmounts"
                                width="100"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="税点"
                                prop="taxThreshold"
                                width="80"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="服务数"
                                prop="taskServiceCount"
                                width="70"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="notVispGuest()"
                                        type="text"
                                        @click="
                                            openDistribTaskViewDialog(
                                                'view',
                                                scope.row
                                            )
                                        "
                                        >{{
                                            scope.row.taskServiceCount
                                        }}</el-button
                                    >
                                    <span v-else>{{
                                        scope.row.taskServiceCount
                                    }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="服务日期"
                                prop="distributeDate"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="操作时间"
                                prop="createTime"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                v-if="notVispGuest()"
                                label="操作"
                                width="100"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        @click="
                                            openDistribTaskViewDialog(
                                                'view',
                                                scope.row
                                            )
                                        "
                                        >查看详情</el-button
                                    >
                                    <el-dropdown
                                        v-if="isDeletableDblTask(scope.row)"
                                        size="small"
                                        trigger="click"
                                        @command="
                                            handleDistribTaskCommand(
                                                arguments[0],
                                                scope.row
                                            )
                                        "
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view"
                                                >查看详情</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                command="delete"
                                                divided
                                                >删除任务</el-dropdown-item
                                            >
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination
                            background
                            v-show="showTaskSummaryQueryPager"
                            @current-change="
                                onTaskSummaryQueryCurrentPageChange
                            "
                            :current-page.sync="
                                taskSummaryQueryForm.currentPage
                            "
                            :page-size="taskSummaryQueryForm.pageSize"
                            layout="prev, pager, next, total, slot"
                            :total="taskSummaryQueryTotal"
                        >
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button
                                        :class="{
                                            active:
                                                taskSummaryQueryForm.pageSize ==
                                                10,
                                        }"
                                        @click="
                                            onTaskSummaryQueryPageSizeChange(10)
                                        "
                                        >10</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                taskSummaryQueryForm.pageSize ==
                                                20,
                                        }"
                                        @click="
                                            onTaskSummaryQueryPageSizeChange(20)
                                        "
                                        >20</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                taskSummaryQueryForm.pageSize ==
                                                50,
                                        }"
                                        @click="
                                            onTaskSummaryQueryPageSizeChange(50)
                                        "
                                        >50</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                taskSummaryQueryForm.pageSize ==
                                                100,
                                        }"
                                        @click="
                                            onTaskSummaryQueryPageSizeChange(
                                                100
                                            )
                                        "
                                        >100</el-button
                                    >
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 导入Dialog -->
                    <el-drawer
                        v-if="notVispGuest()"
                        size="70%"
                        :visible.sync="archiveTaskImportDialogVisible"
                        @closed="closeArchiveTaskImportDialog"
                    >
                        <span slot="title" class="el-drawer-title"
                            >导入清单</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="
                                    archiveTaskImportRules
                                "
                                ref="archiveTaskImportForm"
                                :model="archiveTaskImportForm"
                                :rules="archiveTaskImportRules"
                                label-width="160px"
                            >
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="服务类型"
                                            prop="serviceType"
                                        >
                                            <el-col :span="16">
                                                <el-select
                                                    v-model="
                                                        archiveTaskImportForm.serviceType
                                                    "
                                                    clearable
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        label="汽车服务"
                                                        :value="1"
                                                    ></el-option>
                                                    <el-option
                                                        label="市场营销"
                                                        :value="2"
                                                    ></el-option>
                                                    <el-option
                                                        label="车辆安全检测"
                                                        :value="3"
                                                    ></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="团队长"
                                            prop="leaderStaffId"
                                        >
                                            <el-col :span="16">
                                                <el-select
                                                    v-model="
                                                        archiveTaskImportForm.leaderStaffId
                                                    "
                                                    placeholder="团队长(支持名称或身份证模糊搜索)"
                                                    clearable
                                                    filterable
                                                    remote
                                                    :remote-method="
                                                        loadLeaderStaffs
                                                    "
                                                    :loading="
                                                        leaderStaffQueryLoading
                                                    "
                                                    @clear="
                                                        clearLeaderStaffQuerySelectOptions
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in leaderStaffQuerySelectOptions"
                                                        :key="item.staffId"
                                                        :label="item.staffName"
                                                        :value="item.staffId"
                                                        class="leader-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.idcard
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.staffName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="任务发布方(来款公司)"
                                            prop="taskProduceOrgId"
                                        >
                                            <el-col :span="16">
                                                <el-select
                                                    v-model="
                                                        archiveTaskImportForm.taskProduceOrgId
                                                    "
                                                    clearable
                                                    filterable
                                                    :filter-method="
                                                        filterAllOrgs
                                                    "
                                                    @visible-change="
                                                        resetOrgSelectFilterQuery
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in taskSummaryQueryOrgSelectOptions"
                                                        :key="item.orgId"
                                                        :label="item.orgName"
                                                        :value="item.orgId"
                                                        class="org-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.orgCode
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.orgName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips">
                                                    来款公司
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col
                                        :span="12"
                                        v-if="showArchiveTaskConsumeOrgSelect"
                                    >
                                        <el-form-item
                                            label="任务接受方(服务公司)"
                                            prop="taskConsumeOrgId"
                                            :rules="[
                                                {
                                                    required: true,
                                                    message:
                                                        '请选择任务接受方!',
                                                },
                                            ]"
                                        >
                                            <el-col :span="16">
                                                <el-select
                                                    v-model="
                                                        archiveTaskImportForm.taskConsumeOrgId
                                                    "
                                                    clearable
                                                    filterable
                                                    :filter-method="
                                                        filterAllOrgs
                                                    "
                                                    @visible-change="
                                                        resetOrgSelectFilterQuery
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in taskSummaryQueryOrgSelectOptions"
                                                        :key="item.orgId"
                                                        :label="item.orgName"
                                                        :value="item.orgId"
                                                        class="org-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.orgCode
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.orgName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips">
                                                    服务公司
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="分派日期"
                                            prop="distributeDate"
                                        >
                                            <el-col :span="16">
                                                <el-date-picker
                                                    style="width: 100%"
                                                    v-model="
                                                        archiveTaskImportForm.distributeDate
                                                    "
                                                    type="date"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                >
                                                </el-date-picker>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips">
                                                    即服务日期
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="税点"
                                            prop="taxThreshold"
                                        >
                                            <el-col :span="16">
                                                <el-input
                                                    v-model="
                                                        archiveTaskImportForm.taxThreshold
                                                    "
                                                    :maxlength="10"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips">
                                                    百分点.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="营销员所属公司"
                                            prop="serviceStaffOrgId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        archiveTaskImportForm.serviceStaffOrgId
                                                    "
                                                    clearable
                                                    filterable
                                                    :filter-method="
                                                        filterAllOrgs
                                                    "
                                                    @visible-change="
                                                        resetOrgSelectFilterQuery
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in taskSummaryQueryOrgSelectOptions"
                                                        :key="item.orgId"
                                                        :label="item.orgName"
                                                        :value="item.orgId"
                                                        class="org-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.orgCode
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.orgName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    当导入表格中的营销员在系统中不存在时，系统会自动创建营销员，此时若不指定则默认跟团队长同属一个组织机构。
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="上传EXCEL文件"
                                            prop="uploadExcelFilePath"
                                        >
                                            <el-col :span="12">
                                                <el-upload
                                                    class="upload-excel"
                                                    ref="archiveTaskImportUploader"
                                                    name="uploadFile"
                                                    :multiple="false"
                                                    :limit="1"
                                                    :on-exceed="
                                                        handleImportExcelExceed
                                                    "
                                                    :headers="uploadHeaders"
                                                    :action="
                                                        importExcelUploadUrl
                                                    "
                                                    :data="
                                                        importExcelUploadParam
                                                    "
                                                    :before-upload="
                                                        beforeImportExcelUpload
                                                    "
                                                    :on-remove="
                                                        handleImportExcelRemove
                                                    "
                                                    :on-success="
                                                        handleImportExcelUploadSuccess
                                                    "
                                                    :on-error="
                                                        handleUploadError
                                                    "
                                                >
                                                    <el-button
                                                        slot="trigger"
                                                        size="small"
                                                        type="primary"
                                                        icon="fas fa-plus-circle"
                                                        >选择文件</el-button
                                                    >
                                                    <a
                                                        class="excel-template"
                                                        href="javascript:;"
                                                        @click="
                                                            downloadTemplateExcel
                                                        "
                                                        >下载模板</a
                                                    >
                                                    <div
                                                        class="el-upload__tip"
                                                        slot="tip"
                                                    >
                                                        只能上传xls|xlsx格式的EXCEL文件，大小不超过1MB!
                                                    </div>
                                                </el-upload>
                                                <div
                                                    v-if="
                                                        showArchiveTaskImportFeedback
                                                    "
                                                >
                                                    <p class="import-feedback">
                                                        上传EXCEL中部分数据校验不通过，请点此<a
                                                            href="javascript:;"
                                                            @click="
                                                                downloadFeedbackExcel
                                                            "
                                                            >链接下载</a
                                                        >反馈信息予以更正并重新上传导入.
                                                    </p>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    若EXCEL表格中的营销员或服务对象不存在，则系统会自动创建。
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeArchiveTaskImportDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="importArchiveTask"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看任务服务清单Dialog -->
                    <el-drawer
                        v-if="notVispGuest()"
                        :with-header="false"
                        size="80%"
                        :visible.sync="distribTaskViewDialogVisible"
                        @closed="closeDistribTaskViewDialog"
                    >
                        <div class="el-drawer-content">
                            <el-tabs
                                class="el-drawer-content-body"
                                v-model="distribTaskViewActiveTabName"
                            >
                                <el-tab-pane
                                    label="任务详情信息"
                                    name="distribTaskViewBasicInfo"
                                >
                                    <el-form
                                        class="el-form-detail"
                                        inline
                                        label-position="right"
                                        label-width="120px"
                                        label-suffix="："
                                    >
                                        <el-form-item label="任务ID">{{
                                            distribTaskViewForm.taskId
                                        }}</el-form-item>
                                        <el-form-item label="任务名称">{{
                                            distribTaskViewForm.taskName
                                        }}</el-form-item>

                                        <el-form-item label="任务类型">{{
                                            distribTaskViewForm.taskSourceName
                                        }}</el-form-item>
                                        <el-form-item label="服务类型">{{
                                            distribTaskViewForm.serviceTypeName
                                        }}</el-form-item>

                                        <el-form-item label="任务发布方">{{
                                            distribTaskViewForm.taskProduceOrgName
                                        }}</el-form-item>
                                        <el-form-item label="任务接受方">{{
                                            distribTaskViewForm.taskConsumeOrgName
                                        }}</el-form-item>

                                        <el-form-item label="团队长">{{
                                            distribTaskViewForm.leaderStaffName
                                        }}</el-form-item>
                                        <el-form-item label="分派日期">{{
                                            distribTaskViewForm.distributeDate
                                        }}</el-form-item>

                                        <el-form-item label="分派金额">{{
                                            distribTaskViewForm.distributeAmounts
                                        }}</el-form-item>
                                        <el-form-item label="分派金额区间">{{
                                            distribTaskViewForm.amountRange
                                        }}</el-form-item>

                                        <el-form-item label="含税分派金额">{{
                                            distribTaskViewForm.taxedDistributeAmounts
                                        }}</el-form-item>
                                        <el-form-item label="税点">{{
                                            distribTaskViewForm.taxThreshold
                                        }}</el-form-item>

                                        <el-form-item
                                            label="服务数"
                                            style="width: 100%"
                                            >{{
                                                distribTaskViewForm.taskServiceCount
                                            }}</el-form-item
                                        >

                                        <el-form-item label="操作时间">{{
                                            distribTaskViewForm.createTime
                                        }}</el-form-item>
                                        <el-form-item label="操作人">{{
                                            distribTaskViewForm.createByName
                                        }}</el-form-item>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane
                                    label="任务分派清单"
                                    name="distribTaskViewService"
                                >
                                    <visp-task-service
                                        :task-id="distribTaskViewForm.taskId"
                                        :service-type="
                                            distribTaskViewForm.serviceType
                                        "
                                        :is-producer="isProducer"
                                    ></visp-task-service>
                                </el-tab-pane>
                            </el-tabs>
                            <div
                                class="el-drawer-content-footer"
                                style="padding: 15px 0"
                            >
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeDistribTaskViewDialog"
                                    >取 消</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort, parseFilename } from '@/utils.js';
import FileSaver from 'file-saver';
import { ALL_ORG_ID } from '@/visp.js';

const EXCEL_TYPES = ['xls', 'xlsx'];
const AMOUNT_PATTERN = /^([0-9])+(\.[0-9]{1,2})?$/;

export default {
    name: 'DistribTaskSummary',
    data() {
        return {
            submiting: false,
            allOrgList: [],
            orgSelectFilterQuery: '',
            leaderStaffQueryLoading: false,
            leaderStaffQuerySelectOptions: [],

            taskSummaryList: [],
            taskSummaryQueryLoading: false,
            taskSummaryQuering: false,
            taskSummaryQueryExpanded: true,
            taskSummaryQueryForm: {
                taskSource: '',
                taskId: '',
                taskProduceOrgId: '',
                taskConsumeOrgId: '',
                distributeDateRange: [],
                startDistributeDate: '',
                endDistributeDate: '',
                leaderStaffId: '',
                distributeAmounts: '',
                onlyShowMyDistributes: '',
                pageSize: 10,
                currentPage: 1,
            },
            taskSummaryQueryTotal: 0,
            taskSummaryQuerySort: {
                prop: 'createTime',
                order: 'descending',
            },
            selectedSummaryTaskIds: [],
            archiveTaskImportDialogVisible: false,
            showArchiveTaskImportFeedback: false,
            importExcelUploadUrl: PLATFORM_API.of(
                '/api/xupload/protected/file'
            ),
            importExcelUploadParam: {
                renameStrategy: 'ORIGINAL_FILENAME_AND_UUID',
                formatLimit: EXCEL_TYPES.join(','),
            },
            archiveTaskImportForm: {
                uploadExcelFileName: '',
                uploadExcelFilePath: '',
                serviceType: '',
                leaderStaffId: '',
                serviceStaffOrgId: '',
                taskConsumeOrgId: '',
                taskProduceOrgId: '',
                distributeDate: '',
                taxThreshold: '',
            },
            archiveTaskImportRules: {
                serviceType: [
                    {
                        type: 'number',
                        required: true,
                        message: '请选择服务类型!',
                    },
                ],
                leaderStaffId: [
                    {
                        type: 'number',
                        required: true,
                        message: '请选择团队长!',
                    },
                ],
                taxThreshold: [
                    {
                        required: true,
                        message: '税点不能为空!',
                    },
                    {
                        pattern: AMOUNT_PATTERN,
                        message: '税点必须是非负数且小数部分至多2位!',
                    },
                ],
                taskProduceOrgId: [
                    {
                        type: 'number',
                        required: true,
                        message: '请选择任务发布方!',
                    },
                ],
                distributeDate: [
                    {
                        required: true,
                        message: '请选择分派日期!',
                    },
                ],
                uploadExcelFilePath: [
                    {
                        required: true,
                        message: '请选择导入Excel文件!',
                    },
                ],
            },
            distribTaskViewDialogVisible: false,
            distribTaskViewActiveTabName: 'distribTaskViewBasicInfo',

            distribTaskViewForm: {
                taskId: '',
                taskName: '',
                taskSource: '',
                taskSourceName: '',
                serviceType: '',
                serviceTypeName: '',
                leaderStaffId: '',
                leaderStaffName: '',
                distributeDate: '',
                distributeAmounts: '',
                taxedDistributeAmounts: '',
                amountRange: '',
                taxThreshold: '',
                taskProduceOrgId: '',
                taskProduceOrgName: '',
                taskConsumeOrgId: '',
                taskConsumeOrgName: '',
                createTime: '',
                createBy: '',
                createByName: '',
                taskServiceCount: '',
            },
        };
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        showTaskSummaryQueryPager() {
            if (this.taskSummaryQuering || this.taskSummaryQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        taskSummaryQueryOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter((org) => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                return this.allOrgList.filter((org) => true);
            }
        },
        showArchiveTaskConsumeOrgSelect() {
            //如果当前用户是拥有全部组织的人?那么需要展示选择任务接受方的，否则默认使用当前操作人的所属组织作为任务接受方
            return this.loginUser.orgId == ALL_ORG_ID;
        },
        uploadHeaders() {
            let headers = {
                Accept: 'application/json',
            };
            let accessToken = this.$store.getters.getAccessToken();
            if (accessToken && accessToken.access_token) {
                headers['Authorization'] = 'bearer ' + accessToken.access_token;
            }
            return headers;
        },
        isProducer() {
            return (
                this.distribTaskViewForm.taskProduceOrgId ==
                this.loginUser.orgId
            );
        },
    },
    created() {},
    mounted() {
        this.loadAllOrgList();
        this.queryTaskSummaryList(1000);
    },
    methods: {
        notVispGuest() {
            return this.loginUser.primaryRoleCode != 'guest';
        },
        isDeletableDblTask(row) {
            //当前登录者创建的任务
            return (
                row.taskSource == 3 &&
                (ALL_ORG_ID == this.loginUser.orgId ||
                    row.taskConsumeOrgId == this.loginUser.orgId)
            );
        },
        filterAllOrgs(value) {
            this.orgSelectFilterQuery = value;
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then((response) => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        resetOrgSelectFilterQuery() {
            this.orgSelectFilterQuery = '';
        },
        loadLeaderStaffs(query) {
            if (query) {
                this.leaderStaffQueryLoading = true;
                let url = PLATFORM_API.of('/api/platform/visp/staff/leaders');
                this.$http
                    .get(url, {
                        params: { staffName: query, idcard: query },
                    })
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.leaderStaffQuerySelectOptions = result.data;
                        } else {
                            this.leaderStaffQuerySelectOptions = [];
                        }
                    })
                    .catch((error) => {
                        this.leaderStaffQuerySelectOptions = [];
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        this.leaderStaffQueryLoading = false;
                    });
            }
        },
        clearLeaderStaffQuerySelectOptions() {
            this.leaderStaffQuerySelectOptions = [];
        },
        exportTaskSummary(exportType) {
            if (this.selectedSummaryTaskIds.length) {
                this.doExportTaskSummary(
                    exportType,
                    this.selectedSummaryTaskIds.join(',')
                );
            } else {
                this.$message.error('请选择要导出的任务!');
                return false;
            }
        },
        doExportTaskSummary(exportType, taskIds) {
            this.submiting = true;
            let url = PLATFORM_API.of(
                '/api/platform/visp/tasksummary/export/batch?exportType=' +
                    exportType
            );
            this.$http
                .post(
                    url,
                    {
                        taskIds: taskIds,
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler)
                .then(() => {
                    this.submiting = false;
                });
        },
        toggleTaskSummaryQueryExpand() {
            this.taskSummaryQueryExpanded = !this.taskSummaryQueryExpanded;
        },
        queryTaskSummaryList(loading) {
            this.taskSummaryQueryForm.currentPage = 1;
            this.doQueryTaskSummaryList(loading);
        },
        doQueryTaskSummaryList(loading) {
            this.taskSummaryQuering = true;
            if (loading) {
                this.taskSummaryQueryLoading = true;
            }
            setTimeout(() => {
                this.taskSummaryQueryForm.startDistributeDate =
                    this.taskSummaryQueryForm.distributeDateRange[0];
                this.taskSummaryQueryForm.endDistributeDate =
                    this.taskSummaryQueryForm.distributeDateRange[1];
                let params = Object.assign(
                    {},
                    this.taskSummaryQueryForm,
                    mapSort(this.taskSummaryQuerySort)
                );
                delete params.distributeDateRange;
                this.$http
                    .get(
                        PLATFORM_API.of('/api/platform/visp/tasksummary/list'),
                        {
                            params: params,
                        }
                    )
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.taskSummaryList = result.data;
                            this.taskSummaryQueryTotal = result.totalRowCount;
                        } else {
                            this.taskSummaryList = [];
                            this.taskSummaryQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch((error) => {
                        this.taskSummaryList = [];
                        this.taskSummaryQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.taskSummaryQueryLoading = false;
                        }
                        this.taskSummaryQuering = false;
                    });
            }, loading);
        },
        resetTaskSummaryQueryForm() {
            this.$refs.taskSummaryQueryForm.resetFields();
        },
        onTaskSummaryQuerySortChange(parameter) {
            if (
                this.taskSummaryQuerySort.prop != parameter.prop ||
                this.taskSummaryQuerySort.order != parameter.order
            ) {
                this.taskSummaryQuerySort.prop = parameter.prop;
                this.taskSummaryQuerySort.order = parameter.order;
                this.queryTaskSummaryList(1000);
            }
        },
        onTaskSummaryQueryPageSizeChange(pageSize) {
            this.taskSummaryQueryForm.pageSize = pageSize;
            this.queryTaskSummaryList(1000);
        },
        onTaskSummaryQueryCurrentPageChange(currentPage) {
            this.taskSummaryQueryForm.currentPage = currentPage;
            this.doQueryTaskSummaryList(1000);
        },
        onTaskSummarySelectionChange(selectedRows) {
            if (selectedRows && selectedRows.length) {
                this.selectedSummaryTaskIds = [];
                selectedRows.forEach((row) => {
                    this.selectedSummaryTaskIds.push(row.taskId);
                });
            } else {
                this.selectedSummaryTaskIds = [];
            }
        },
        openArchiveTaskImportDialog() {
            this.clearLeaderStaffQuerySelectOptions();
            this.archiveTaskImportDialogVisible = true;
        },
        closeArchiveTaskImportDialog() {
            this.archiveTaskImportDialogVisible = false;
            this.showArchiveTaskImportFeedback = false;
            this.$refs.archiveTaskImportForm.resetFields();
            this.$refs.archiveTaskImportUploader.clearFiles();
        },
        importArchiveTask() {
            let url = PLATFORM_API.of('/api/platform/visp/archivetask/import');
            this.$refs.archiveTaskImportForm.validate((valid) => {
                if (valid && !this.submiting) {
                    this.submiting = true;
                    setTimeout(() => {
                        this.$http
                            .post(url, this.archiveTaskImportForm)
                            .then((response) => {
                                let result = response.data;
                                if (result.success) {
                                    this.closeArchiveTaskImportDialog();
                                    this.$message.success(result.message);
                                    this.resetTaskSummaryQueryForm();
                                    this.taskSummaryQueryForm.taskIds =
                                        result.data;
                                    this.queryTaskSummaryList(1000);
                                } else {
                                    this.$message.error(result.message);
                                }
                            })
                            .catch((error) => {
                                defaultApiErrorHandler.call(
                                    this,
                                    error,
                                    (result) => {
                                        if (result.code == 400) {
                                            this.showArchiveTaskImportFeedback = true;
                                        }
                                    }
                                );
                            })
                            .then(() => {
                                this.submiting = false;
                            });
                    }, 1500);
                } else {
                    return false;
                }
            });
        },
        downloadTemplateExcel() {
            let url = PLATFORM_API.of('/api/xdownload/store/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName: '清单批量导入模板.xlsx',
                        targetFilePath:
                            '/excel/templates/清单批量导入模板.xlsx',
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        downloadFeedbackExcel() {
            let url = PLATFORM_API.of('/api/xdownload/temp/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName:
                            this.archiveTaskImportForm.uploadExcelFileName,
                        targetFilePath:
                            this.archiveTaskImportForm.uploadExcelFilePath,
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        beforeImportExcelUpload(file) {
            let fileName = file.name;
            if (fileName.replace(/\s+/g, '') != fileName) {
                this.$message.error('上传文件名不能包含空格!');
                return false;
            }
            let fileType = fileName
                .substring(fileName.lastIndexOf('.') + 1)
                .toLowerCase();
            if (EXCEL_TYPES.indexOf(fileType) == -1) {
                this.$message.error(
                    '上传文件只能是EXCEL(xls、xlsx)格式的文件!'
                );
                return false;
            }
            if (file.size > 0 && file.size / 1024 / 1024 > 1) {
                this.$message.error('上传EXCEL文件大小不能超过1MB!');
                return false;
            }
            return true;
        },
        handleImportExcelExceed(file, fileList) {
            this.$message.error('最多只能上传一个文件!若要重新上传请先删除.');
            return false;
        },
        handleImportExcelUploadSuccess(response, file, fileList) {
            file.path = response.data.path;
            this.archiveTaskImportForm.uploadExcelFileName = response.data.name;
            this.archiveTaskImportForm.uploadExcelFilePath = response.data.path;
            this.showArchiveTaskImportFeedback = false;
            this.$refs.archiveTaskImportForm.validateField(
                'uploadExcelFilePath'
            );
        },
        handleImportExcelRemove(file, fileList) {
            this.showArchiveTaskImportFeedback = false;
            this.archiveTaskImportForm.uploadExcelFileName = '';
            this.archiveTaskImportForm.uploadExcelFilePath = '';
            if (file && file.path) {
                this.$http.get(
                    PLATFORM_API.of(
                        '/api/xupload/protected/remove?path=' + file.path
                    )
                );
            }
        },
        handleUploadError(error, file, fileList) {
            try {
                let result = JSON.parse(error.message);
                this.$message.error(result.message);
            } catch (e) {
                console.error(e);
            }
        },
        handleDistribTaskCommand(cmd, row) {
            if (cmd == 'view') {
                this.openDistribTaskViewDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteDistribTask(row);
            }
        },
        openDistribTaskViewDialog(cmd, row) {
            this.distribTaskViewActiveTabName = 'distribTaskViewBasicInfo';
            this.distribTaskViewDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.distribTaskViewForm).forEach((name) => {
                    this.distribTaskViewForm[name] = row[name];
                });
            });
        },
        closeDistribTaskViewDialog() {
            this.distribTaskViewDialogVisible = false;
            Object.keys(this.distribTaskViewForm).forEach((name) => {
                this.distribTaskViewForm[name] = '';
            });
        },
        deleteDistribTask(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/archivetask/delete/' + row.taskId
            );
            this.$confirm('您确定要删除该任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$http
                    .delete(url)
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.$message.success(result.message);
                            this.queryTaskSummaryList(1000);
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler);
            });
        },
    },
};
</script>
<style lang="scss">
.upload-excel {
    display: block;
    position: relative;

    .excel-template {
        display: inline-block;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 13px;
    }
}
.org-select-option,
.leader-select-option {
    .option-left {
        float: left;
        color: $--color-primary;
        font-size: 13px;
        padding-right: 50px;
    }
    .option-right {
        float: right;
    }
}
.import-feedback {
    margin-top: 10px;
    padding: 10px;
    line-height: 1.5;
    background-color: mix($--color-white, $--color-danger, 90%);
    border-radius: 4px;
    font-size: 13px;
    color: $--color-danger;
    a {
        color: $--color-blue;
    }
}
.idcard {
    color: $--color-gray;
}
.task-service-details {
    list-style-position: inside;
    padding: 5px 15px 5px 5px;
    .name {
        color: $--color-primary;
    }
}
.task-query-expander {
    height: 36px;
    line-height: 36px;
    color: $--color-primary;
    cursor: pointer;
}
.task-query-form {
    padding-bottom: 15px !important;
    .el-row {
        .el-form-item {
            margin-bottom: 5px !important;
        }
    }
}
</style>